/* istanbul ignore file */
import {PropTypes} from 'prop-types';

export default {
    trace: PropTypes.func.isRequired,
    debug: PropTypes.func.isRequired,
    info: PropTypes.func.isRequired,
    warn: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
    fatal: PropTypes.func.isRequired,
};
